
import { forEach as _forEach } from '@lodash';
import AbstractMapper from '@core/utils/mappers/AbstractMapper';
import IBroadcastDto from '@core/mappers/broadcast/dtos/IBroadcastDto';
import Broadcast from '@core/models/broadcast/Broadcast';
import { getChannelLogo } from '@src/data/tvChannels';

export default class BroadcastMapper extends AbstractMapper<IBroadcastDto, Broadcast> {

    createTargetObject(dto: IBroadcastDto): Broadcast {
        const broadcast = new Broadcast();

        broadcast.betRadarId = dto.EventId;
        broadcast.name = dto.Name;
        broadcast.type = dto.Type;
        broadcast.channels = dto.Channels.map((channel) => ({
            id: channel.BroadcastId,
            name: channel.Name,
            logo: getChannelLogo(channel.Name),
        }));

        return broadcast;
    }

    // custom map implementation to avoid multiple loops on same array
    // instead array of target objects, function returns map <eventId, broadcast>
    map(source: any): any {
        const models:any = {};

        _forEach(source, (item: IBroadcastDto) => {
            models[item.EventId] = this.createTargetObject(item);
        });

        return models;
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/core/mappers/broadcast/BroadcastMapper.ts